import { useEffect, useRef, useCallback } from "react";
import { createSocket } from "../utils/websocket";

export function useLabSocket({
  labId,
  token,
  onMessage,
  onOpen,
  onClose,
}) {
  const socketRef = useRef(null);
  const mountedRef = useRef(false);

  // =========================
  // CONNECT ONLY ONCE PER labId+token
  // =========================
  useEffect(() => {
    if (!labId || !token) return;

    mountedRef.current = true;

    console.log("🟡 Connecting socket for:", labId);

    const socket = createSocket(token, labId);

    socketRef.current = socket;

    socket.onopen = () => {
      console.log("🟢 Socket Open:", labId);
      onOpen?.();
    };

    socket.onmessage = (event) => {
      try {
        const msg = JSON.parse(event.data);
        onMessage?.(msg);
      } catch (err) {
        console.error("Invalid WS message:", err);
      }
    };

    socket.onclose = () => {
      console.log("🔴 Socket Closed:", labId);
      onClose?.();

      // 🚨 IMPORTANT: prevent auto-loop reconnect storms
      if (mountedRef.current) {
        console.log("⏳ Waiting for lab...");
      }
    };

    socket.onerror = (err) => {
      console.error("⚠️ Socket error:", err);
    };

    return () => {
      console.log("🧹 Cleaning socket:", labId);

      mountedRef.current = false;

      if (socket) {
        socket.onopen = null;
        socket.onmessage = null;
        socket.onerror = null;
        socket.onclose = null;
        socket.close();
      }

      socketRef.current = null;
    };
  }, [labId, token]);

  // =========================
  // SAFE SEND
  // =========================
  const send = useCallback((data) => {
    const socket = socketRef.current;

    if (!socket || socket.readyState !== WebSocket.OPEN) {
      console.warn("Socket not ready");
      return;
    }

    socket.send(JSON.stringify(data));
  }, []);

  return { send, socketRef };
}